import styled from 'styled-components';

export const Container = styled.div`
	width: 1000px;
	max-width: 100%;
	padding: 0 5px;
	margin: 93px auto;
	min-height: 300px;
`;

export const StyledShowcase = styled.div`
	color: ${({ theme }) => theme.colors.white};

	justify-content: space-between;
	margin: 20px 0 8px;
	z-index: 0;
	text-align: justify;
	text-justify: inter-word;

	> div {
		padding: 40px 0;
	}

	h1 {
		color: ${({ theme }) => theme.colors.header};
		margin: 10px 0;
	}
`;
